module.exports = __webpack_public_path__ + "img/living-tv-console.17c8184e.webp";